import { render, staticRenderFns } from "./SpaceConfigurationsSelector.vue?vue&type=template&id=52b3f376&scoped=true"
import script from "./SpaceConfigurationsSelector.vue?vue&type=script&lang=ts"
export * from "./SpaceConfigurationsSelector.vue?vue&type=script&lang=ts"
import style0 from "./SpaceConfigurationsSelector.vue?vue&type=style&index=0&id=52b3f376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3f376",
  null
  
)

export default component.exports